<template>
  <div class="wrappercontainer">
    <ul class="progressbar">
      <li
        :class="i.stageStatus == 1 ? 'active' : ''"
        v-for="(i, index) in steps"
        :key="i.index"
      >
        {{ i.stageName }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    steps: { type: Array, required: true },
  },
  data() {
    return {};
  },
};
</script>

(html comment removed:  Add "scoped" attribute to limit CSS to this component only )
<style >
.wrappercontainer {
  width: 100%;
  position: relative;
  z-index: 1;
  margin-top: 2px;
}
.progressbar {
  counter-reset: steps;
}
.progressbar li {
  float: left;
  width: 14.28%;
  position: relative;
  text-align: center;
}
.progressbar li:before {
  content: counter(steps);
  counter-increment: steps;
  width: 30px;
  height: 30px;
  border: 2px solid #bebebe;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 27px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}
.progressbar li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background: #979797;
  top: 15px;
  left: -50%;
  z-index: -1;
}
.progressbar li.active:before {
  border-color: #3aac5d;
  background: #3aac5d;
  color: white;
}
.progressbar li.active:after {
  background: #3aac5d;
}
.progressbar li.active - li:after {
  background: #3aac5d;
}
.progressbar li.active - li:before {
  border-color: #3aac5d;
  background: #3aac5d;
  color: white;
}
.progressbar li:first-child:after {
  content: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/StepProgressSlider.vue